import { t } from '../lib/i18n.js';

// Lange Tabellen kürzen: <table data-truncate="15"> zeigt die ersten 15 Zeilen
// und einen Button für den Rest. Ohne JavaScript bleibt die Tabelle vollständig.
export default function tableTruncate() {
  document.querySelectorAll('table[data-truncate]').forEach(function (table) {
    const limit = parseInt(table.dataset.truncate, 10);
    const rows = Array.from(table.tBodies[0] ? table.tBodies[0].rows : []);
    if (!(limit > 0) || rows.length <= limit + 2) return;

    const rest = rows.slice(limit);
    // Zeigt der URL-Anker auf eine der hinteren Zeilen (Rücksprung nach dem
    // Speichern, etwa von Domain-Tags), bleibt die Tabelle ausgeklappt.
    const id = decodeURIComponent(window.location.hash.slice(1));
    const target = id ? document.getElementById(id) : null;
    const expanded = target !== null && rest.some(function (row) { return row.contains(target); });
    rest.forEach(function (row) { row.hidden = !expanded; });

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn-small table-more';
    const showAll = t('Alle {count} anzeigen', { count: rows.length });
    const showFirst = t('Nur die ersten {count} anzeigen', { count: limit });
    button.textContent = expanded ? showFirst : showAll;
    button.setAttribute('aria-expanded', String(expanded));
    button.addEventListener('click', function () {
      const open = button.getAttribute('aria-expanded') === 'true';
      rest.forEach(function (row) { row.hidden = open; });
      button.setAttribute('aria-expanded', String(!open));
      button.textContent = open ? showAll : showFirst;
    });

    const wrapper = table.closest('.table-wrap') || table;
    wrapper.insertAdjacentElement('afterend', button);
  });
}
